window.addEventListener('load', () => {
  const HASH = '#judgeme-write-review-slot';
  const BUTTON_SELECTOR = [
    '#judgeme-write-review-slot [data-testid="write-review-button"]',
    '#judgeme-write-review-slot .jdgm-write-rev-link',
    '#judgeme-write-review-slot .jm-button.jm-button--primary.jm-action-buttons__button',
    '#judgeme-write-review-slot .jm-button.shop-brushes-button',
  ].join(', ');

  let observer = null;

  function getButton() {
    return document.querySelector(BUTTON_SELECTOR);
  }

  function openWhenReady() {
    const button = getButton();
    if (!button) return false;

    button.click();
    return true;
  }

  function stopWatching() {
    observer?.disconnect();
    observer = null;
  }

  function tryOpenWriteReview() {
    if (window.location.hash !== HASH) return;

    if (openWhenReady()) {
      stopWatching();
      return;
    }

    if (observer) return;

    observer = new MutationObserver(() => {
      if (openWhenReady()) stopWatching();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  tryOpenWriteReview();
  window.addEventListener('hashchange', tryOpenWriteReview);
});
